import(/* webpackMode: "eager" */ "/vercel/path0/apps/imqa-next-sample/app/settings/page.tsx");
